import {
  connect
} from 'react-redux';
import EditIndex from '../../components/Clients/EditClientProfile/Index';

const mapStateToProps = (state) => {
  const { edit_client_profile } = state.clients;
  const { roleName } = state.app;
  return {
    edit_client_profile,
    roleName
  }
}

const mapDispatchToProps = (dispatch) => {
  return {

  }
}

const EditIndexContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(EditIndex);

export default EditIndexContainer




// WEBPACK FOOTER //
// ./src/containers/Clients/editIndex.js